var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEraserActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.4473 33.2759H24.85L37.7619 19.8642L37.7626 19.8634C38.3962 19.2013 38.7496 18.3114 38.7496 17.3863C38.7496 16.4612 38.3962 15.5714 37.7626 14.9092L37.7611 14.9076L27.0811 3.88337L27.0715 3.87349L27.0612 3.86439L26.8982 3.72065C26.8979 3.72038 26.8976 3.7201 26.8973 3.71983C26.2405 3.13287 25.3903 2.82184 24.5173 2.85195C23.6438 2.88207 22.8158 3.25125 22.1991 3.88226L22.1976 3.88377L2.23877 24.5513L2.2374 24.5527C1.60328 25.2169 1.24961 26.1086 1.24961 27.0356C1.24961 27.9626 1.60328 28.8543 2.23739 29.5185L2.23878 29.5199L9.50402 37.0431L9.60722 37.1499H9.75579H33.4473H33.7973V36.7999V33.6259V33.2759H33.4473ZM10.7614 21.2081L24.6333 6.87774L34.821 17.4284L20.9771 31.7299L10.7614 21.2081ZM11.1997 33.2759L5.17849 27.0352L8.10265 23.9955L17.123 33.2759H11.1997Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.7
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEraserActive);
export default __webpack_public_path__ + "static/media/eraser_active.7ae75cd313de1b281e1294c6213d0b2c.svg";
export { ForwardRef as ReactComponent };